import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './Sidebar.module.scss';

const Sidebar: React.FC = () => {
	const { setGroup, mediaSettingsForUpdate, documentSettingsForUpdate, selectedGroup } =
		useContext<IStyleContext>(StyleContext);
	const hasAdditionalSettingsAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.RESTAURANT_MANAGER,
		UserRoles.TECHNICAL,
	]);

	return (
		<>
			{mediaSettingsForUpdate[0]?.groups.length ? (
				<div className={style.container} data-test="Sidebar">
					<SidebarItem
						onClick={() => setGroup({ id: 'colorsID', key: 'colorsKey' })}
						isActive={selectedGroup?.id === 'colorsID'}
						label="colors"
					/>
					{mediaSettingsForUpdate[0].groups.map((el) => (
						<SidebarItem
							onClick={() => setGroup(el)}
							isActive={selectedGroup?.id === el.id}
							label={el.key}
							key={el.id}
						/>
					))}
					{documentSettingsForUpdate.map((el) => (
						<SidebarItem
							onClick={() => setGroup({ id: el.id, key: el.key ? el.key : '' })}
							isActive={selectedGroup?.id === el.id}
							label={el.key ? el.key : ''}
							key={el.id}
						/>
					))}
					{hasAdditionalSettingsAccess && (
						<SidebarItem
							onClick={() => setGroup({ id: 'additionalSettingFileID', key: 'additional_setting_file' })}
							isActive={selectedGroup?.id === 'additionalSettingFileID'}
							label="additional_setting_file"
						/>
					)}
				</div>
			) : null}
		</>
	);
};

export default React.memo(Sidebar);
